import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { CircularProgress } from '@mui/material';
import MarkdownEditor from 'new/components/LexicalMarkdownEditor';

import './ReusableDocEditor.scss';

type Props = {
  initialText?: string;
  onChangeText?(text: string): void;
  onDiscardChangesClick(): void;
  onSaveDocumentationClick(text: string): void;
};

export default function ReusableDocEditor(props: Props) {
  const { initialText = '' } = props;
  const [text, setText] = useState(initialText);
  const [loading, setLoading] = useState(true);

  const handleOnChangeText = useCallback(
    (value: string) => {
      setText(value);
      props.onChangeText?.(value);
    },
    [props.onChangeText],
  );

  useEffect(() => {
    setTimeout(() => setLoading(false), 500);
  }, []);

  if (loading) {
    return (
      <section className="reusable-doc-editor-container-loading">
        <CircularProgress color="primary" />
      </section>
    );
  }

  return (
    <section className="reusable-doc-editor-container">
      <div className="detail-row">
        <div className="detail-col">
          <div id="doc-editor-container">
            <MarkdownEditor
              // Baseline stays the loaded doc (stable) so the editor doesn't
              // re-sync mid-typing; `text` is the working copy for Save. No
              // placeholder — a new transform just shows an empty editor.
              committedValue={{ value: initialText }}
              onChange={handleOnChangeText}
              // chromeless so the editor fills the bounded panel and scrolls its
              // content internally — keeps Save/Discard reachable on long docs.
              chromeless
            />
          </div>

          <div className="doc-content-buttons-row">
            <Button variant="outlined" onClick={props.onDiscardChangesClick}>
              <span>Discard Changes</span>
            </Button>
            <Button variant="contained" onClick={() => props.onSaveDocumentationClick(text)}>
              <span>Save</span>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
